'use strict';

angular.module('footer')

.controller('ProgrammeFooterCtrl', function ($scope, $state, programme, kdAuth, kdLogin, $document)
{
    $scope.programme = programme;
    $scope.kdAuth = kdAuth;
    $scope.kdLogin = kdLogin;

    var masterProgramme = programme;

    if (programme.parent) {
        masterProgramme = programme.parent;
    }

    $scope.languages = [masterProgramme];

    angular.forEach(masterProgramme.children, function (child)
    {
        if (child.language.enabled) {
            $scope.languages.push(child);
        }
    });

    $scope.switchLanguage = function (model)
    {
        $state.go('programme', {programmeSlug: model.slug});
    };

    $scope.goTop = function()
    {
        $document[0].body.scrollTop = 0;
        $document[0].documentElement.scrollTop = 0;
    }
});
